export enum EDamageKind {
  Cannon = 0,
  Rocket = 1,
  Grenade = 2,
  Bullet = 3,
  Sniper = 4,
  // Lightning = 5, // Lightning is the same as cannon
  // Beam = 6, // Beam is the same as cannon
}
